var _style, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_965_",
    d: "M18.57,14.55l-5.39-5.39c-0.1-0.1-0.26-0.1-0.35,0l-5.39,5.39c-0.1,0.1-0.1,0.26,0,0.35l0.8,0.8 c0.1,0.1,0.26,0.1,0.35,0l3.61-3.61v9.49c0,0.14,0.11,0.25,0.25,0.25h1.12c0.14,0,0.25-0.11,0.25-0.25v-9.49l3.61,3.61 c0.1,0.1,0.26,0.1,0.35,0l0.8-0.8C18.67,14.8,18.67,14.64,18.57,14.55z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_960_",
    d: "M22.75,6.99l-6.32-6.37C16.04,0.22,15.5,0,14.95,0H4.73C3.58,0,2.64,0.94,2.64,2.1V23.9 c0,1.16,0.94,2.1,2.09,2.1h16.55c1.15,0,2.09-0.94,2.09-2.1V8.47C23.36,7.91,23.14,7.38,22.75,6.99z M16.29,2.78l4.3,4.34h-3.84 c-0.25,0-0.46-0.21-0.46-0.47V2.78z M21.27,24.38H4.73c-0.25,0-0.46-0.21-0.46-0.47V2.1c0-0.26,0.21-0.47,0.46-0.47h9.94v5.03 c0,1.16,0.94,2.1,2.09,2.1h4.98V23.9C21.73,24.16,21.53,24.38,21.27,24.38z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocList);
export default __webpack_public_path__ + "static/media/DocList.8ecbc0aa51a8f54d3ee7e62d4c0c6194.svg";
export { ForwardRef as ReactComponent };